module.exports = __webpack_public_path__ + "static/media/log_bgg.a20b04a9.png";